export default "__VITE_ASSET__0SQnR0rW__"